import gql from "graphql-tag";
import Client from "Apolloclient";
import store from "store/store";
import * as types from './lotti.types';
import * as actions from './lotti.actions';

export function SalvaLotto(name, contractNumber, description, contractId, sectors) {
    const sectorsId = sectors.map(s => s.id);
    var variables = {name, contractNumber, description, contractId, sectors: sectorsId};

    let query = {
        fetchPolicy: 'no-cache',
        variables: variables,
        mutation: gql`,
            mutation create (
            $name: String!
            $description: String
            $contractId: String
            $sectors: [String]
            $contractNumber: String
        ) {
            createdObject: createLot (
                name: $name,
                description: $description,
                contractId: $contractId,
                contractNumber: $contractNumber,
                sectors: $sectors,
            ) {
                id
                name
                description
                contractNumber
                sectors
                signConfig
                contract {
                    id
                    description
                    startDate
                    endDate
                    company
                } 
            }
        }
        `
    };

    return Client
        .mutate(query)
        .then(async (response) => {
            var data = response.data.createdObject;

            if (process.env.NODE_ENV === 'development') {
                data = JSON.parse(JSON.stringify(data));
            }

            store.dispatch(actions.created(data));

            return {
                hasError: false
            }
        })
        .catch((e) => {
            var message = 'Impossibile creare il lotto';
            console.error(e);

            if (e.graphQLErrors && e.graphQLErrors.length > 0) {
                message = e.graphQLErrors[0].message;
            }

            return {
                hasError: true,
                message: message
            };
        });
}

export function OttieniLotti() {

    store.dispatch({
        type: types.REQUEST_READ_ALL
    })

    var variables = {};

    let query = {
        fetchPolicy: 'network-only',
        variables: variables,
        query: gql`,
     {
            objectList: lots {
                description
                id
                name
                sectors
                signConfig
                contractNumber
                contract {
                    description
                    id
                }
            }
            }
        `,
    };
    return Client
        .query(query).then(
            async response => {

                var data = response.data.objectList;

                store.dispatch(
                    {
                        type: types.READED_ALL,
                        payload: data
                    }
                );

                return;
            }
        ).catch(
            e => {
                var message = "Impossibile ottenere i lotti"
                console.error(e);

                if (e.graphQLErrors && e.graphQLErrors.length > 0) {
                    message = e.graphQLErrors[0].message;
                }

                store.dispatch({
                    type: types.READ_ALL_ERROR
                });

                return {
                    hasError: true,
                    message: message
                }
            }
        );
}

export function AggiornaLotto(id, name, number, description, contractid, contractnumber, newSectors, signConfig) {

    let sectors = newSectors.map(sec => (sec.id));

    const variables = {id, name, number, description, contractid, contractnumber, sectors,signConfig};

    let query = {
        fetchPolicy: 'no-cache',
        variables: variables,
        mutation: gql`,
        mutation update(
            $id: String!,
            $name: String!
            $description: String
            $contractid: String
            $contractnumber: String
            $sectors: [String]
            $signConfig: String
        ){
            updatedObject: updateLot(
                id: $id,
                name: $name,
                description: $description,
                contractId: $contractid,
                contractNumber: $contractnumber,
                sectors: $sectors,
                signConfig: $signConfig
            ) {
                description
                id
                name
                signConfig
                contractNumber
                sectors
                contract {
                    description
                    id
                }
            }
        }
        `
    };

    return Client
        .mutate(query)
        .then(async (response) => {
            var data = response.data.updatedObject;

            store.dispatch(actions.updated(data));

            return {
                hasError: false
            }
        })
        .catch((e) => {
            var message = 'Impossibile aggiornare il lotto';
            console.error(e);

            if (e.graphQLErrors && e.graphQLErrors.length > 0) {
                message = e.graphQLErrors[0].message;
            }
            return {
                hasError: true,
                message: message
            }
        });
}

export function EliminaLotto(id) {
    var variables = {id};

    let query = {
        fetchPolicy: 'no-cache',
        variables: variables,
        mutation: gql`,
        mutation (
            $id: String!
        ) {
            deleted: deleteLot (id: $id) {
                id
            }
        }
        `
    };

    store.dispatch(actions.requestDelete(id));

    return Client
        .mutate(query)
        .then(async (response) => {
            var data = response.data.deleted;

            store.dispatch(actions.deleted(data));

            return {
                hasError: false
            }
        })
        .catch((e) => {
            var message = 'Impossibile eliminare il lotto';
            console.error(e);
            store.dispatch(actions.deleteError(id));


            if (e.graphQLErrors && e.graphQLErrors.length > 0) {
                message = e.graphQLErrors[0].message;
            }

            return {
                hasError: true,
                message: message
            }
        });
}
